import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  task: null,
  theatreList: [],
};

export const fleetTaskFormSlice = createSlice({
  name: "fleetTaskForm",
  initialState,
  reducers: {
    initializeTaskForm: (state, { payload }) => {
      state.task = payload.task;
      state.theatreList = payload.theatreList;
    },
    updateTask: (state, { payload }) => {
      state.task = { ...state.task, ...payload };
    },
    addTheatres: (state, { payload }) => {
      const existing = new Set(state?.theatreList?.map((t) => t?.uuid));
      state.theatreList = [
        ...(state?.theatreList || []),
        ...payload.filter((t) => !existing.has(t?.uuid)),
      ];
    },
    removeTheatre: (state, { payload }) => {
      state.theatreList = state?.theatreList?.filter((t) => t?.uuid !== payload);
    },
    resetTaskForm: () => initialState,
  },
});

export const { initializeTaskForm, updateTask, addTheatres, removeTheatre, resetTaskForm } =
  fleetTaskFormSlice.actions;
